import { render, staticRenderFns } from "./ModalMainData.vue?vue&type=template&id=220bf431&scoped=true"
import script from "./ModalMainData.vue?vue&type=script&lang=js"
export * from "./ModalMainData.vue?vue&type=script&lang=js"
import style0 from "./ModalMainData.vue?vue&type=style&index=0&id=220bf431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bf431",
  null
  
)

export default component.exports